import React, { useEffect, useState } from 'react';
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/common/Navbar";
import CustomDashBoard from "./page/CustomDashBoard";
import WarrentySubmitPage from "./page/WarrentySubmitPage";
import LandingPage from "./page/LandingPage";
import SmartTable from "./page/SmartTable";
import Forbidden from "./page/Forbidden";
import PocClaimsDashboard from "./page/poc/PocClaimsDashboard";
import PocClaimSubmit from "./page/poc/PocClaimSubmit";
import PocClaimHistory from "./page/poc/PocClaimHistory";
import PocClaimDetails from "./page/poc/PocClaimDetails";
import WarrantyPolicies from "./page/admin/WarrantyPolicies";
import AuthorizationRules from "./page/admin/AuthorizationRules";
import { PocAccessProvider } from "./components/poc/PocAccess";
import { apiOrigin as getApiOrigin, buildLoginUrl } from "./services/apiClient";
import { fetchSession } from "./services/authApi";

function App() {
  // Gates the whole app shell on a valid, authorized Entra ID session -
  // mirrors iai_iica's "/" route check, adapted for a SPA that has to ask
  // the backend (GET /auth/session) rather than checking a server-rendered
  // template's own state.
  const [authChecked, setAuthChecked] = useState(false);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const apiOrigin = getApiOrigin();

    fetchSession()
      .then((res) => res.json())
      .then((data) => {
        if (!data.authenticated) {
          window.location.href = buildLoginUrl(apiOrigin);
          return;
        }
        if (!data.authorized && window.location.pathname !== "/forbidden") {
          window.location.href = "/forbidden";
          return;
        }
        setUserName(data.name || "");
        setAuthChecked(true);
      })
      .catch(() => {
        // Can't reach the backend to check - fail safe by attempting
        // sign-in rather than silently showing the app with no data access.
        window.location.href = buildLoginUrl(apiOrigin);
      });
  }, []);

  if (!authChecked) {
    return null;
  }

  return (
    <PocAccessProvider>
      <Navbar userName={userName}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/claim" element={<WarrentySubmitPage />} />
          <Route path="/reports" element={<CustomDashBoard />} />
          <Route path="/smarttable" element={<SmartTable />} />
          <Route path="/forbidden" element={<Forbidden />} />
          {/* Phase 4B-UI: POC claim adjudication and warranty administration (admin pages check the role themselves). */}
          <Route path="/poc-claims" element={<PocClaimsDashboard />} />
          <Route path="/poc-claims/new" element={<PocClaimSubmit />} />
          <Route path="/poc-claims/history" element={<PocClaimHistory />} />
          <Route path="/poc-claims/:claimId" element={<PocClaimDetails />} />
          <Route path="/admin/warranty-policies" element={<WarrantyPolicies />} />
          <Route path="/admin/authorization-rules" element={<AuthorizationRules />} />
        </Routes>
      </Navbar>
    </PocAccessProvider>
  );
}

export default App;